// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.songwriter-empty-catalog {
  border-top: 1px solid #c4c4c4;
  margin-top: 4rem;
  padding-top: 4rem;
  margin-bottom: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.songwriter-empty-catalog p:first-child {
  font-size: 2.8rem;
  line-height: 3.5rem;
  padding-bottom: 0.8rem;
}
.songwriter-empty-catalog p:first-child strong {
  font-weight: 700;
}
.songwriter-empty-catalog p:nth-child(2) {
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 500;
  width: 33rem;
  padding-bottom: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/SongwriterScene/SongwriterCatalogScene/SongwriterCatalogEmptyWarning/index.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAGE;EACE,iBAAA;EACA,mBAAA;EACA,sBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAKE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;AAHJ","sourcesContent":["@use '@Styles/variables';\n\n.songwriter-empty-catalog {\n  border-top: 1px solid variables.$greyColorForBorder;\n  margin-top: 4rem;\n  padding-top: 4rem;\n  margin-bottom: 4rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  p:first-child {\n    font-size: 2.8rem;\n    line-height: 3.5rem;\n    padding-bottom: 0.8rem;\n\n    strong {\n      font-weight: 700;\n    }\n  }\n\n  p:nth-child(2) {\n    font-size: 1.6rem;\n    line-height: 2.4rem;\n    font-weight: 500;\n    width: 33rem;\n    padding-bottom: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
